// packages/interface/src/index.js
export * from "./components/index.mjs";
import { store } from "./store/index.mjs";
export {
  store
};
//# sourceMappingURL=index.mjs.map
